/* KissProm-style interactions (works alongside Dawn) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function toast(msg) {
    var t = $('.kp-toast');
    if (!t) { t = document.createElement('div'); t.className = 'kp-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 2400);
  }

  /* ---------- drawers / modals ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
  }
  function closeDrawers() {
    $$('.kp-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-kp-open]'); if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-kp-open')); return; }
    if (e.target.closest('[data-kp-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- collection toolbar ---------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-kp-sort]')) {
      var u = new URL(window.location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page');
      window.location.href = u.toString();
    }
    if (e.target.matches('[data-kp-nav]')) window.location.href = e.target.getAttribute('data-kp-nav');
  });
  $$('[data-kp-readmore]').forEach(function (box) {
    var inner = $('.kp-collection__desc-inner', box), btn = $('[data-kp-readmore-btn]', box);
    if (inner.scrollHeight <= inner.clientHeight + 4) { btn.hidden = true; return; }
    btn.addEventListener('click', function () { box.classList.toggle('is-open'); btn.textContent = box.classList.contains('is-open') ? 'Read less' : 'Read more'; });
  });

  /* ---------- wishlist (stored in this browser) ---------- */
  var WKEY = 'kp-wishlist';
  function wl() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wlSave(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
  function paintHearts() { var a = wl(); $$('[data-kp-wish]').forEach(function (b) { b.classList.toggle('is-on', a.indexOf(b.getAttribute('data-kp-wish')) > -1); }); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kp-wish]'); if (!b) return;
    e.preventDefault(); var h = b.getAttribute('data-kp-wish'), a = wl(), i = a.indexOf(h);
    if (i > -1) { a.splice(i, 1); toast('Removed from wishlist'); } else { a.push(h); toast('Added to wishlist'); }
    wlSave(a); paintHearts();
  });
  paintHearts();

  /* ---------- cart (uses Dawn's cart drawer when present) ---------- */
  function addToCart(body) {
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    body.sections = sections; body.sections_url = window.location.pathname;
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || res.message || 'Could not add to cart');
      if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
      else window.location.href = '/cart';
      return res;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-kp-add]'); if (!b) return;
    e.preventDefault(); b.disabled = true;
    addToCart({ items: [{ id: Number(b.getAttribute('data-kp-add')), quantity: 1 }] })
      .catch(function (err) { toast(err.message); })
      .finally(function () { b.disabled = false; });
  });

  /* ---------- generic horizontal sliders ---------- */
  function bindSlider(root) {
    if (root._kp) return; root._kp = true;
    var track = $('.kp-slider__track', root); if (!track) return;
    $$('[data-kp-slide]', root).forEach(function (btn) {
      btn.addEventListener('click', function () { track.scrollBy({ left: Number(btn.getAttribute('data-kp-slide')) * track.clientWidth * 0.8 }); });
    });
  }
  $$('[data-kp-slider]').forEach(bindSlider);

  /* ---------- product page ---------- */
  var pdp = $('[data-kp-product]');
  if (pdp) {
    var variants = JSON.parse(($('[data-kp-variants]') || {}).textContent || '[]');
    var idInput = $('[data-kp-variant-id]', pdp);
    var form = idInput ? idInput.form : null;
    var atc = $('[data-kp-atc]', pdp), atcLabel = $('[data-kp-atc-label]', pdp);
    var track = $('[data-kp-track]', pdp);

    function selected() {
      var opts = [];
      $$('[data-kp-opt]', pdp).forEach(function (el) {
        var i = Number(el.getAttribute('data-kp-opt'));
        if (el.tagName === 'SELECT') opts[i] = el.value || null; else if (el.checked) opts[i] = el.value;
      });
      return opts;
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < opts.length; j++) if (opts[j] != null && variants[i].options[j] !== opts[j]) { ok = false; break; }
        if (ok) return variants[i];
      }
      return null;
    }
    function goToMedia(id) {
      if (!track || !id) return;
      var slide = $('[data-media-id="' + id + '"]', track);
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function applyVariant(v) {
      if (!v) { atc.disabled = true; atcLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      atc.disabled = !v.available; atcLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      var price = $('[data-kp-price]', pdp);
      if (price) price.innerHTML = v.compare ? '<s class="kp-price--was">' + v.compare + '</s><span class="kp-price--sale">' + v.price + '</span>' : '<span>' + v.price + '</span>';
      var sp = $('[data-kp-sticky-price]'); if (sp) sp.textContent = v.price;
      var sku = $('[data-kp-sku]', pdp); if (sku && v.sku) sku.textContent = v.sku;
      goToMedia(v.media);
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
    }
    function selectedValueIds() {
      var ids = [];
      $$('[data-kp-opt]', pdp).forEach(function (el) {
        if (el.tagName === 'SELECT') { var o = el.options[el.selectedIndex]; if (o && o.dataset.ovid) ids.push(o.dataset.ovid); }
        else if (el.checked && el.dataset.ovid) ids.push(el.dataset.ovid);
      });
      return ids;
    }
    var reqId = 0;
    function fetchVariant(opts) {
      /* Liquid only exposes the first 250 variants; look up the rest through the Section Rendering API. */
      var ids = selectedValueIds(), my = ++reqId;
      atc.disabled = true; atcLabel.textContent = 'Loading…';
      var url = (pdp.dataset.url || window.location.pathname) + '?option_values=' + ids.join(',') + '&section_id=' + pdp.dataset.section;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        if (my !== reqId) return;
        var doc = new DOMParser().parseFromString(html, 'text/html'), el = doc.querySelector('[data-kp-current]');
        var v = el ? JSON.parse(el.textContent) : null;
        if (v && opts.every(function (val, i) { return val == null || v.options[i] === val; })) { variants.push(v); applyVariant(v); }
        else applyVariant(null);
      }).catch(function () { if (my === reqId) applyVariant(null); });
    }
    function onChange() {
      var opts = selected(), v = findVariant(opts);
      opts.forEach(function (val, i) { var l = $('[data-kp-opt-label="' + i + '"]', pdp); if (l) l.textContent = val || ''; });
      $$('.kp-tile', pdp).forEach(function (t) { var r = $('input', t); t.classList.toggle('is-active', r.checked); });
      if (!v) { fetchVariant(opts); return; }
      reqId++;
      applyVariant(v);
    }
    $$('[data-kp-opt]', pdp).forEach(function (el) { el.addEventListener('change', onChange); });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = $('[data-kp-error]', pdp); err.hidden = true;
      /* Other scripts can add line-item properties (custom measurements, notes) or block the add with an error. */
      var detail = { properties: {}, error: null };
      form.dispatchEvent(new CustomEvent('kp:before-add', { detail: detail }));
      if (detail.error) { err.textContent = detail.error; err.hidden = false; err.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      var item = { id: Number(idInput.value), quantity: 1 };
      if (Object.keys(detail.properties).length) item.properties = detail.properties;
      atc.disabled = true;
      addToCart({ items: [item] })
        .catch(function (ex) { err.textContent = ex.message; err.hidden = false; })
        .finally(function () { atc.disabled = false; });
    });

    /* gallery arrows + dots */
    if (track) {
      var slides = $$('.kp-gallery__slide', track);
      var prev = $('[data-kp-prev]', pdp), next = $('[data-kp-next]', pdp), dots = $('[data-kp-dots]', pdp);
      var step = function () { return slides[0] ? slides[0].getBoundingClientRect().width + 6 : track.clientWidth; };
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
      if (dots && slides.length > 1) dots.innerHTML = slides.map(function (_, i) { return '<span' + (i === 0 ? ' class="is-active"' : '') + '></span>'; }).join('');
      var upd = function () {
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if (dots) { var i = Math.round(track.scrollLeft / step()); $$('span', dots).forEach(function (d, j) { d.classList.toggle('is-active', i === j); }); }
      };
      track.addEventListener('scroll', function () { clearTimeout(track._t); track._t = setTimeout(upd, 60); }, { passive: true });
      upd();
      /* lightbox */
      track.addEventListener('click', function (e) {
        var a = e.target.closest('[data-kp-zoom]'); if (!a) return; e.preventDefault();
        var box = document.createElement('div');
        box.className = 'kp-drawer kp-drawer--modal is-open';
        box.innerHTML = '<div class="kp-drawer__overlay" data-kp-close></div><div class="kp-drawer__panel" style="width:min(1000px,96vw);max-height:94vh"><div class="kp-drawer__head"><span></span><button type="button" class="kp-drawer__close" data-kp-close aria-label="Close">×</button></div><div class="kp-drawer__body" style="padding:0"><img src="' + a.href + '" style="width:100%;display:block" alt=""></div></div>';
        document.body.appendChild(box); document.body.style.overflow = 'hidden';
        box.addEventListener('click', function (ev) { if (ev.target.closest('[data-kp-close]')) { box.remove(); document.body.style.overflow = ''; } });
      });
    }

    /* delivery estimate (business days) */
    $$('[data-kp-estimate]').forEach(function (el) {
      function add(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) n--; } return d; }
      var f = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
      var out = $('[data-kp-estimate-dates]', el);
      if (out) out.textContent = f(add(Number(el.getAttribute('data-min')))) + ' – ' + f(add(Number(el.getAttribute('data-max'))));
    });

    /* share */
    var sh = $('[data-kp-share]');
    if (sh) sh.addEventListener('click', function () {
      var url = sh.getAttribute('data-url'), title = sh.getAttribute('data-title');
      if (navigator.share) navigator.share({ title: title, url: url }).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { toast('Link copied'); });
    });

    /* sticky bar */
    var sticky = $('[data-kp-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
      }).observe(atc);
    }

    /* pairs well with */
    var pairs = $('[data-kp-pairs]');
    if (pairs) fetch(pairs.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), c = doc.querySelector('[data-kp-pairs-content]');
      if (c && c.children.length) { $('[data-kp-pairs-list]', pairs).innerHTML = c.innerHTML; pairs.hidden = false; }
    }).catch(function () {});
  }

  /* recommendations (More You'll Love) */
  $$('[data-kp-recs]').forEach(function (box) {
    if (box.children.length) { $$('[data-kp-slider]', box).forEach(bindSlider); return; }
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), fresh = doc.querySelector('[data-kp-recs]');
      if (fresh && fresh.innerHTML.trim()) { box.innerHTML = fresh.innerHTML; $$('[data-kp-slider]', box).forEach(bindSlider); paintHearts(); }
    }).catch(function () {});
  });
})();
